import styled from "styled-components"
import InputText from "../shared/input/new/InputText"
import { useEffect, useState } from "react"
import InputTextarea from "../shared/input/new/InputTextarea"
import InputSelect from "../shared/input/new/InputSelect"
import { menuOptions, sendOptions, subMenuOptions } from '../../utils/bildirimOptions'
import Btn from "../shared/button/Btn"
import { clearScheduledData, sendNotification, setMobileNotification, setNotificationMenu, setNotificationSubMenu, setNotificationText, setNotificationTitle } from "../../features/admin4/admin4Slice"
import { useDispatch } from "react-redux"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import { useSelector } from "react-redux"
import { MdOutlineCheck } from "react-icons/md";
import RegularMonthSelectContainer from "./RegularMonthSelectContainer"
import RegularWeekSelectContainer from "./RegularWeekSelectContainer"
import TargetDateNotificationContainer from "./TargetDateNotificationContainer"

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    width: 100%;

    .check-container{
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        .checkbox{
            width: 20px;
            height: 20px;
            border: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .process-seperator{
        width: 100%;
        background-color: ${({theme}) => theme.mainBorderColor};
        height: 1px;
    }

    .extra-content-container{
        display: flex;
        margin: 20px 0;
        gap: ${({selectedSendType}) => selectedSendType ? "50px" : 0} ;

        .select-side{
            display: flex;
            gap: 20px;

        }

        .select-result-side{
            display: flex;
            flex-direction: column;

    
        }
    }
`

const SendNotificationAll = () => {

    const dispatch = useDispatch()

    const {
        notificationTitle,

        notificationText,
    
        notificationMenu,
    
        notificationSubMenu,
    
        mobileNotification,

        isLoadingSendNotification

    } = useSelector(state => state.admin4)

    const [selectedSendType, setSelectedSendType] = useState({
        id:null,
        text: ""
    })

    useEffect(() => {
        dispatch(clearScheduledData())
    },[selectedSendType.id])

    const handleCheck = () => {
        dispatch(setMobileNotification(!mobileNotification))
    }

    const handleClickNow = () => {
        if(!notificationTitle || !notificationText || !notificationMenu.value){

        }
        else{
            const dataa ={message:notificationText, tittle:notificationTitle, screenName:notificationSubMenu.value, routeName:notificationMenu.value, notificationAdded: mobileNotification }
              dispatch(sendNotification(dataa))
        }
    }
 
  return (
    <Container selectedSendType={selectedSendType.id !== null}>
        <InputText data={notificationTitle} setData={(e) => dispatch(setNotificationTitle(e.target.value))} labelText="Bildirim Başlığı" inputWidth={"350px"} name={"title"}/>
        <InputTextarea data={notificationText} setData={(e) => dispatch(setNotificationText(e.target.value))} labelText={"Bildirim Metni"}  inputWidth={"350px"} name={"content"}/>
        <InputSelect data={notificationMenu?.text} setData={(item) => dispatch(setNotificationMenu({item, pastNotificationMenu: notificationMenu}))} initialOptions={menuOptions} labelText={"Menü"} inputWidth={"350px"} name={"menu"}/>
        <InputSelect data={notificationSubMenu?.text} setData={(item) => dispatch(setNotificationSubMenu(item))} initialOptions={subMenuOptions.filter(item => item?.mainMenu === notificationMenu?.value)} labelText={"Alt Menü"} inputWidth={"350px"} name={"subMenu"}/>
        <div onClick={handleCheck} className="check-container">
            <div className="checkbox">
                {
                    mobileNotification && <MdOutlineCheck />
                }
            </div>
            <p>Mobil uygulamadan bildirim gönderilsin.</p>
        </div>
        <div className="process-seperator"/>
        <div className="extra-content-container">
            <div className="select-side">
                <InputSelect data={selectedSendType?.text} setData={(item) => setSelectedSendType(item)} initialOptions={sendOptions} labelText={"Gönderim Tipi Seçiniz"} inputWidth={"350px"} name={"sendOptions"}/>
            </div>
            <div className="select-result-side">

                {
                    selectedSendType.id === 0 &&
                    <RegularMonthSelectContainer isAll={true}/>
                }

                {
                    selectedSendType.id === 1 &&
                    <RegularWeekSelectContainer isAll={true}/>
                }

                {
                    selectedSendType.id === 2 &&
                    <TargetDateNotificationContainer isAll={true}/>
                }

                {
                    selectedSendType.id === 3 &&
                    <Btn handleClick={handleClickNow} bgColor="#E85546" color="#fff" width={"350px"}>{isLoadingSendNotification ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Gönder"}</Btn>
                }
            </div>
        </div>
    </Container>
  )
}

export default SendNotificationAll